import CategorySelector from "@beeldit/ecommerce/categories/components/CategorySelector";
import ProductSelector from "@beeldit/ecommerce/products/components/ProductSelector";
import ProductMultiSelector from "@beeldit/ecommerce/products/components/ProductMultiSelector";
import UserSelector from "@beeldit/user-and-access/users/components/UserSelector";
import ProducerSelector from "@main/producers/components/ProducerSelector";
import CustomerSelector from "@main/customers/components/CustomerSelector";
import BeelditTypeSelector from "@beeldit/core/components/BeelditTypeSelector";
import IconSelector from "@bloonde/cms/cms-tags/components/IconSelector";

const projectWidgets: any = {
    "category-selector": CategorySelector,
    "product-selector": ProductSelector,
    "producer-selector": ProducerSelector,
    "customer-selector": CustomerSelector,
    "product-multi-selector": ProductMultiSelector,
    "user-selector": UserSelector,
    "type-selector": BeelditTypeSelector,
    "icon-selector": IconSelector,
};

export default projectWidgets;
